import * as t from 'io-ts';
import { nullable } from './nullable';
export var ErrorMessage = t.type({
  message: t.string
});
var ErrorWithPath = t.union([ErrorMessage, t.type({
  path: nullable(t.array(t.string))
})]);
export var UnprocessableEntityError = t.intersection([t.type({
  __typename: t.literal('UnprocessableEntityError'),
  extensions: nullable(t.type({
    fullMessages: t.array(t.string)
  }))
}), ErrorWithPath]);